import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import {
  actionCreators,
  IForgotPasswordState,
} from '../modules/forgotPassword'

type ForgotPasswordPageProps = IForgotPasswordState & typeof actionCreators

export default class ForgotPasswordPage extends React.PureComponent<
  ForgotPasswordPageProps
> {
  constructor(props: ForgotPasswordPageProps) {
    super(props)
    bindFunctions(this)
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    return (
      <DocumentTitle title='Forgot Password'>
        <Container className='mt-5'>
          <Row>
            <Col className='text-center'>
              <img
                src='/images/HB_Logo_Square_150.png'
                width='150'
                height='150'
              />
            </Col>
          </Row>
          {this.props.hasRequestedPin
            ? this._renderResetPassword()
            : this._renderRequestPin()}
        </Container>
      </DocumentTitle>
    )
  }

  private _onResetPassword(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    this.props.resetPassword()
  }

  private _onSendPinCode(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    this.props.sendPin()
  }

  private _renderRequestPin() {
    const mdColSize = { size: 8, offset: 2 }
    const lgColSize = { size: 6, offset: 3 }

    return (
      <Form className='mt-5' onSubmit={this._onSendPinCode}>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <FormGroup>
              <Label>Email (we will send you a password reset pin code)</Label>
              <Input
                autoFocus
                name='Username'
                onChange={(e) => this.props.setUsername(e.target.value)}
                placeholder='me@haagbrown.com'
                required
                type='text'
                value={this.props.username}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <Button
              className='w-100'
              color='primary'
              disabled={!this.props.isValid || this.props.isSaving}
            >
              Send Me a Pin Code
            </Button>
          </Col>
        </Row>
      </Form>
    )
  }

  private _renderResetPassword() {
    const mdColSize = { size: 8, offset: 2 }
    const lgColSize = { size: 6, offset: 3 }

    return (
      <Form className='mt-5' onSubmit={this._onResetPassword}>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <FormGroup>
              <Label>Email</Label>
              <Input
                name='Username'
                onChange={(e) => this.props.setUsername(e.target.value)}
                placeholder='me@haagbrown.com'
                required
                readOnly
                type='text'
                value={this.props.username}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <FormGroup>
              <Label>Pin Code</Label>
              <Input
                name='PinCode'
                onChange={(e) => this.props.setPinCode(e.target.value)}
                required
                type='text'
                value={this.props.pinCode}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <FormGroup>
              <Label>Password</Label>
              <Input
                name='Password'
                onChange={(e) => this.props.setPassword(e.target.value)}
                required
                type='password'
                value={this.props.password}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <FormGroup>
              <Label>Verify Password</Label>
              <Input
                name='VerifyPassword'
                onChange={(e) => this.props.setVerifyPassword(e.target.value)}
                required
                type='password'
                value={this.props.verifyPassword}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={mdColSize} lg={lgColSize}>
            <Button
              className='w-100'
              color='primary'
              disabled={!this.props.isValid || this.props.isSaving}
            >
              Reset Password
            </Button>
          </Col>
        </Row>
      </Form>
    )
  }
}
